import React, { useState, useRef, useEffect } from 'react';
import { Eye, Pencil, MoreVertical, ExternalLink } from 'lucide-react';

const iconBtnStyle = {
  width: '30px',
  height: '30px',
  borderRadius: '6px',
  border: '1px solid #e5e7eb',
  backgroundColor: '#ffffff',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  transition: 'all 0.15s ease',
  padding: 0,
};

const PurchaseActions = ({ batch, onView, onEdit }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    if (!dropdownOpen) return;
    const handleClick = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [dropdownOpen]);

  return (
    <div style={{ display: 'inline-flex', alignItems: 'center', gap: '4px', position: 'relative' }}>
      <button
        title="View Details"
        onClick={() => onView?.(batch)}
        style={iconBtnStyle}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = '#f0fdfa';
          e.currentTarget.style.borderColor = '#11a8a4';
          e.currentTarget.style.color = '#11a8a4';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = '#ffffff';
          e.currentTarget.style.borderColor = '#e5e7eb';
          e.currentTarget.style.color = 'inherit';
        }}
      >
        <Eye size={14} />
      </button>
      <button
        title="Edit"
        onClick={() => onEdit?.(batch)}
        style={iconBtnStyle}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = '#eff6ff';
          e.currentTarget.style.borderColor = '#3b82f6';
          e.currentTarget.style.color = '#3b82f6';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = '#ffffff';
          e.currentTarget.style.borderColor = '#e5e7eb';
          e.currentTarget.style.color = 'inherit';
        }}
      >
        <Pencil size={14} />
      </button>
      <div ref={dropdownRef} style={{ position: 'relative' }}>
        <button
          title="More actions"
          onClick={() => setDropdownOpen(!dropdownOpen)}
          style={iconBtnStyle}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = '#f9fafb';
            e.currentTarget.style.borderColor = '#9ca3af';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = '#ffffff';
            e.currentTarget.style.borderColor = '#e5e7eb';
          }}
        >
          <MoreVertical size={14} />
        </button>
        {dropdownOpen && (
          <div
            style={{
              position: 'absolute',
              right: 0,
              top: '100%',
              marginTop: '4px',
              backgroundColor: '#ffffff',
              border: '1px solid #e5e7eb',
              borderRadius: '8px',
              boxShadow: '0 10px 15px -3px rgba(0,0,0,0.1)',
              minWidth: '160px',
              zIndex: 50,
              padding: '4px',
            }}
          >
            <button
              onClick={() => { onView?.(batch); setDropdownOpen(false); }}
              style={{
                display: 'flex', alignItems: 'center', gap: '8px', width: '100%',
                padding: '8px 12px', border: 'none', background: 'none', cursor: 'pointer',
                fontSize: '13px', color: '#374151', borderRadius: '6px', textAlign: 'left',
              }}
              onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#f3f4f6')}
              onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'transparent')}
            >
              <Eye size={14} /> View Details
            </button>
            <button
              onClick={() => { onEdit?.(batch); setDropdownOpen(false); }}
              style={{
                display: 'flex', alignItems: 'center', gap: '8px', width: '100%',
                padding: '8px 12px', border: 'none', background: 'none', cursor: 'pointer',
                fontSize: '13px', color: '#374151', borderRadius: '6px', textAlign: 'left',
              }}
              onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#f3f4f6')}
              onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'transparent')}
            >
              <Pencil size={14} /> Edit Batch
            </button>
            <button
              onClick={() => { navigator.clipboard?.writeText(batch.invoice_number || ''); setDropdownOpen(false); }}
              style={{
                display: 'flex', alignItems: 'center', gap: '8px', width: '100%',
                padding: '8px 12px', border: 'none', background: 'none', cursor: 'pointer',
                fontSize: '13px', color: '#374151', borderRadius: '6px', textAlign: 'left',
              }}
              onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#f3f4f6')}
              onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'transparent')}
            >
              <ExternalLink size={14} /> Copy Invoice #
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default React.memo(PurchaseActions);
